module.exports = __webpack_public_path__ + "static/media/start.30c57389.png";